import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonLink } from '@naf/button-link';
import { Text, TextVariant } from '@naf/text';
import BenefitList from './BenefitList/BenefitList';
import * as S from './Styles';

type RelatedBenefitsProps = {
  relatedContent: [];
};

const RelatedBenefits = ({ relatedContent }: RelatedBenefitsProps) => (
  <>
    <S.ReadMoreWrapper>
      <Text tag="h2" variant={TextVariant.Header3}>
        Relevante fordeler
      </Text>
      <ButtonLink as={Link} text="Se alle medlemsfordeler" variant="primary" to="/medlemskap/medlemsfordeler" />
    </S.ReadMoreWrapper>
    <BenefitList benefitItems={relatedContent} />
  </>
);

export default RelatedBenefits;
